import { Component } from 'react'
import './styles.sass'

interface SimpleConfirmationModalProps {
  title: string
  text: string
  render: boolean
  onConfirm: () => void
  onClose: () => void
  confirmText?: string
  cancelText?: string
}

export default class SimpleConfirmationModal extends Component<SimpleConfirmationModalProps> {
  render() {
    if (!this.props.render) return null

    return (
      <div className='simple-confirmation-modal-overlay'>
        <div className='simple-confirmation-modal'>
          <div className='modal-header'>
            <h3>{this.props.title}</h3>
          </div>
          <div className='modal-body'>
            <p>{this.props.text}</p>
          </div>
          <div className='modal-footer'>
            <button className='cancel-btn' onClick={this.props.onClose}>
              {this.props.cancelText || 'Cancelar'}
            </button>
            <button className='confirm-btn' onClick={this.props.onConfirm}>
              {this.props.confirmText || 'Confirmar'}
            </button>
          </div>
        </div>
      </div>
    )
  }
}
